/* eslint-disable no-undef */
import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
// import { AdminCloseIcon } from "../../../utils/icons";
import { StyledModalV1 , StyledModalV2} from "../../AttendeesModal/styles";
// import { Border } from "../../Journeys/styles";
import { CommonButtonPopup } from "../../ReportsV2/styles";
// import { CommonButtonBorder } from "../../common/commonStyles";
import { t } from "i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import LazyImage from "../../common/LazyImage/LazyImage";
import { ImageUrl } from "../../../utils/constants";
import { CustomTitle } from "../../UserDashboard/styles";
import { TextContainer } from "./styles";



const ChallengeCompleteModal = ({ showModal, onHide, challenge}) => {


  const renderCompleteChallenge = ()=>{


    window.console.log("")
    
    return(
      <StyledModalV1
        $width={  "550px"}
        $height={"auto !important"}
        show={showModal}
        // onHide={onHide}
        style={{marginTop:"50px"}}
      >
        <div style={{
          // marginTop: "-130px"
          // position: "absolute",
          // top: "-133px",
          // left: "50%",
          // transform: "translateX(-50%)",
          zIndex: "2",
          display: "flex",
          justifyContent: "center"
        }}>
          <LazyImage style={{width:'209px', height:"176px",   marginTop: "-75px"}} src={ImageUrl + "/" + challenge?.challenge_achievement?.challenge_badge}/>
        </div>

        {/* Header */}
        <Modal.Header style={{ background: "white", border: "none" }}>
          <CustomTitle isSize={"32px"} style={{ fontWeight: "700"}}>
            <div className="headerContainer">
              <span  style={{marginTop: "4px"}} className="centeredTitle">Congratulations</span>
            </div>
          </CustomTitle>
        </Modal.Header>
        
        <Modal.Body style={{gap:'16px', display:'flex',  flexDirection:'column',padding:'0px 20px', alignItems:'center',justifyContent:'center'}}
        >

          <TextContainer isFontSize={"24px"} isLineHeight={"30px"} isFontWeight={"400"} isMargin={"12px 0 0 0"}>You Earned</TextContainer>
          <TextContainer isFontSize={"48px"} isLineHeight={"58px"} isFontWeight={"800"} isTextColor={"#2F6C42"}> +{challenge?.challenge_achievement?.challenge_points || 0} XP </TextContainer>
          
          <TextContainer isFontSize={"24px"} isLineHeight={"30px"} isFontWeight={"500"} isTextAlign={"center"}>
           You Have completed {challenge?.challenge_achievement?.challenge_completed_per}% challenge <br/> successfully and earned completion badge
          </TextContainer>
        </Modal.Body>
   
        <Modal.Footer
          style={{
            borderTop: "none",
            display: "flex",
            gap: "12px",
            width: "100%",
            padding:"20px 40px"
          }}
        >
          <div style={{ display: "flex", gap: "12px", marginTop: "20px",width:'100%', justifyContent:'center' }}>
          
            <CommonButtonPopup
              height="40px"
              width="100%"
              onClick={onHide}
            >
              {t("Thank You!")}
            </CommonButtonPopup>
          </div>
        </Modal.Footer>
      </StyledModalV1>

    )}

  const renderInCompleteChallenge = ()=>{

    window.console.log("")

    
    return(
      <StyledModalV2
        $width={"500px !important"}
        $height={"auto !important"}
        show={showModal}
        // onHide={onHide}
        style={{marginTop:"50px"}}
      >
        {/* Header */}
        <Modal.Header style={{ background: "white", border: "none" }}>
          <CustomTitle isSize={"32px"} style={{ fontWeight: "700"}}>
            <div className="headerContainer">
              <span  style={{marginTop: "4px"}} className="centeredTitle">Congratulations</span>
            </div>
          </CustomTitle>
        </Modal.Header>
        {/* Body */}
        <Modal.Body style={{gap:'16px',display:'flex',flexDirection:'column',padding:'0px 20px', alignItems:'center',justifyContent:'center'}}>

          

          <TextContainer isFontSize={"24px"} isLineHeight={"30px"} isFontWeight={"400"} isMargin={"12px 0 0 0"}>You Earned</TextContainer>
          <TextContainer isFontSize={"48px"} isLineHeight={"58px"} isFontWeight={"800"} isTextColor={"#2F6C42"}>{challenge?.challenge_achievement?.challenge_points || 0} XP</TextContainer>
        
        
          <TextContainer isFontSize={"18px"} isLineHeight={"24px"} isTextAlign={"center"} isFontWeight={"500"}>
          As you have not completed full challenge we are unable <br/> to give you the badge better luck next time!
          </TextContainer>
          
        </Modal.Body>
   
        {/* Footer */}
        <Modal.Footer
          style={{
            borderTop: "none",
            display: "flex",
            gap: "12px",
            width: "100%",
            padding:"20px 40px"
          }}
        >
          <div style={{ display: "flex", gap: "12px", marginTop: "20px",width:'100%' }}>
     
            <CommonButtonPopup
              height="40px"
              width="100%"
              onClick={onHide}
            >
              {t("Thank you!")}
            </CommonButtonPopup>
          </div>
        </Modal.Footer>
      </StyledModalV2>
    
    )}

  // const isCompleted = challenge?.challenge_achievement?.challenge_completed_per >= 80;


  return (

    challenge?.challenge_achievement?.challenge_completed_per >= 80 ? renderCompleteChallenge() : renderInCompleteChallenge()
  
  );
};

ChallengeCompleteModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  challengeId:PropTypes.number,
  challenge:PropTypes.object,
  history:PropTypes.object
};

export default withRouter(connect(null, null)(withTranslation()(ChallengeCompleteModal)));
